import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "@4cplatform/elements/Atoms"
import { H1, P } from "@4cplatform/elements/Typography"
import { Button } from "@4cplatform/elements/Molecules"

// Helpers
import { DASHBOARD } from "../../config/pages"

const Forbidden = () => (
  <>
    <Helmet>
      <title>403 Forbidden</title>
    </Helmet>
    <Container isPageContainer width="80%">
      <H1>403 Forbidden</H1>
      <P>You are not authorised to access the requested page.</P>
      <Button type="Link" to={DASHBOARD.path} leadingIcon="chevron-left">
        Back home
      </Button>
    </Container>
  </>
)

export default Forbidden
